import { GET_TITLE_TREE } from 'shared/constants/ActionTypes';
import ItemCollections, { useGetItem } from 'redux/cache';
import { API } from 'shared/constants/AppEnums';
const itemCollections = new ItemCollections();
export const getTitleTree = (id, searchText,useCRSFE=false,closed='0', hideSubDivLpmukp=false) => {
  let keyUrl = useCRSFE ? API.GET_PENANDATANGAN_PENOMORAN_ADMINTOOLS.replace('$id', id) : API.TITLE_TREE_ID.replace('$id', id);
  let useReplacer = useCRSFE ? true : false;
  let save = searchText ? false : true;
  if (searchText){
    if (useCRSFE){
      keyUrl += '?query='+searchText;
    }else{
      keyUrl += '?search='+searchText;
    }
  }
  if (searchText){
    closed === '1' ? keyUrl += '&closed=1' : '';
  }else{
    closed === '1' ? keyUrl += '?closed=1' : '';
  }
  return useGetItem(itemCollections, keyUrl, GET_TITLE_TREE, true, save,useReplacer,useCRSFE, hideSubDivLpmukp);
};
